import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, token, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg)', color:'var(--muted)', fontFamily:'Inter,sans-serif', fontSize:'14px' }}>
        Loading...
      </div>
    );
  }

  if (!token || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Owner can access everything
  if (user.role === 'owner') return children;

  // If specific roles required (only used for owner-only pages)
  if (allowedRoles.length > 0 && allowedRoles.includes('owner') && !allowedRoles.includes(user.role)) {
    return <Navigate to="/jobs" replace />;
  }

  return children;
};

export default ProtectedRoute;
